/**
 * 获取应用列表
 * @returns {Promise<Object>} 返回应用列表数据
 * @throws {Error} 当请求失败时抛出错误
 */
export async function getAppLists() {
  try {
    const res = await fetch("/appsquare/orch/openapi/run", {
      headers: {
        apikey: "sk-01K4KNRT6JBHQ1AQWXMK7E00ED",
        "content-type": "application/json",
        signature: "7c14e76b3b43b5f0224dcc132cf16f984bd57430ad4ff197b8c43dff17c4e594",
      },
      body: '{"widgetId": "625090100037890","userInputs": {}}',
      method: "POST"
    });

    // 检查响应状态
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`请求失败: ${res.status} ${res.statusText} - ${errorText}`);
    }

    const data = await res.json();
    
    // 验证响应数据结构
    if (!data || typeof data !== 'object') {
      throw new Error('响应数据格式无效');
    }

    return data;

  } catch (error) {
    console.log(error);
    return null
  }
}
